import { render } from "./Invite.vue?vue&type=template&id=5cc89e79&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"

import "./Invite.vue?vue&type=style&index=0&id=5cc89e79&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc89e79"]])

export default __exports__